import CopyAllIcon from '@mui/icons-material/CopyAll';
import { Stack, Typography, IconButton } from '@mui/material';

import { CopyToClipBoard } from './CopyToClipBoard';

export const RowStack = ({ field, value, isCopy = false }) => {
  return (
    <Stack direction="row">
      <Typography variant="body2" textAlign="end" gutterBottom sx={{ mr: 2 }}>
        {field}
      </Typography>

      <Typography
        textAlign="start"
        variant="body2"
        display="block"
        overflow="overlay"
        style={{ wordWrap: 'break-word' }}>
        {value}
        {isCopy && value ? (
          <CopyToClipBoard>
            {({ copy }) => (
              <IconButton onClick={() => copy(value)}>
                <CopyAllIcon />
              </IconButton>
            )}
          </CopyToClipBoard>
        ) : null}
      </Typography>
    </Stack>
  );
};
